// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3Kegy","col":"CardReaderDesc_col__11h6j","label":"CardReaderDesc_label__TK2ad"};